import styled from "styled-components/macro";

const SetupForm = styled.form`
    display: flex;
    flex-direction: column;
    margin-bottom: 24px;

    .mantine-Button-root {
        margin-top: 26px;
    }
`;

export default SetupForm;
